<div class="toast pointer-events-auto copyable-error-toast">
    <div class="copyable-error-toast__shell">
        <div class="copyable-error-toast__accent"></div>

        <div class="copyable-error-toast__header">
            <div class="copyable-error-toast__icon">
                <fa-icon [icon]="['fal', 'triangle-exclamation']"></fa-icon>
            </div>
            <div class="copyable-error-toast__title-wrap">
                <h4>{{ data.title }}</h4>
                <p>{{ data.content }}</p>
            </div>
            <button type="button"
                    class="copyable-error-toast__close"
                    [attr.aria-label]="data.closeLabel || 'Close'"
                    (click)="dismiss($event)">
                <fa-icon [icon]="['fal', 'times']"></fa-icon>
            </button>
        </div>

        @if (data.detail) {
        <div class="copyable-error-toast__detail">
            <div class="copyable-error-toast__detail-header">
                <span>{{ data.detailLabel || 'Detail' }}</span>
                <button type="button"
                        class="copyable-error-toast__copy"
                        [class.copyable-error-toast__copy--copied]="copied"
                        (click)="copyDetail($event)">
                    <fa-icon [icon]="copied ? ['fal', 'check'] : ['fal', 'copy']"></fa-icon>
                    <span>{{ copied ? (data.copiedLabel || 'Copied') : (data.copyLabel || 'Copy error') }}</span>
                </button>
            </div>
            <pre>{{ data.detail }}</pre>
        </div>
        }
    </div>
</div>
